import './actionsColumn.less';

import { MenuOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';
import b_ from 'b_';

import { AntMenu, AntMenuInfo } from 'controls/react/ant/antMenu';
import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { GridSelection, GridSelectionMode } from 'controls/grid/gridSelection';
import { GridStore } from 'controls/grid/gridStore';
import { GridMenuPlugin } from 'controls/grid/plugins/grid-menu/gridMenuPlugin';
import { GridDataItem } from 'controls/grid/gridDataItem';
import { ContextMenuSelection } from 'controls/grid/plugins/grid-menu/gridMenuAction';

export type ActionsColumnsProps<DataEntry extends GridDataEntry> = {
	store: GridStore<DataEntry>;
	item: GridDataItem<DataEntry>;
};

const b = b_.with('grid-action-column');

export const MenuActionsColumn = observer(<DataItem extends GridDataEntry>(props: ActionsColumnsProps<DataItem>) => {
	const plugin = props.store.plugins.find((x) => x.id == 'grid-menu') as GridMenuPlugin<DataItem>;

	const gridSelection = new GridSelection(plugin.store);
	gridSelection.ids.push(props.item.id);

	const items = plugin.generateContextMenu(gridSelection);

	const rootItem = {
		key: 'root',
		popupClassName: b('menu-container'),
		icon: <MenuOutlined />,
		children: items,
	};

	const onClick = React.useCallback((item: AntMenuInfo<DataItem>) => {
		const action = plugin.getMenuActionByMenuItem(item);
		let selection = gridSelection;

		if (action.contextMenuSelection == ContextMenuSelection.allSelectedPlusCurrent) {
			selection = plugin.store.selection.copy();
			if (!selection.isSelected(props.item)) {
				if (selection.mode == GridSelectionMode.Include) {
					selection.ids.push(props.item.id);
				} else {
					selection.ids.splice(selection.ids.indexOf(props.item.id), 1);
				}
			}
		}

		void plugin.onMenuItemClick(item, selection);
	}, []);

	return <AntMenu mode={'horizontal'} onClick={onClick} items={[rootItem]} triggerSubMenuAction={'click'} />;
});
